import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

import * as filters from './filters' // global filters

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

Vue.use(ElementUI)

// 一次性解决时区和日期格式问题
import moment from 'moment'
/*eslint no-extend-native: ["error", { "exceptions": ["Date"] }]*/
Date.prototype.toISOString = function() {
  // console.log(this,moment(this).toDate());
  return moment(this).format('YYYY-MM-DDTHH:mm:ss')
}


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
